module.exports = "/public/images/f5fb04643b30822a177c1e6238790bcc.png";